// Generated from data/contact.yaml by scripts/generate.mjs. Do not edit.
import type { Contact } from '@supay-expeditions/model';

export default {
  "company": "Supay Expeditions",
  "address": "Toconao 424-A1",
  "town": "San Pedro de Atacama, Chile",
  "instagram": "@supayexpeditions",
  "email": "contact@supayexpedition.com",
  "web": "supayexpedition.com",
  "phone": "+56 9 5555 0424",
  "people": [
    {
      "name": "First Last",
      "role": "Tour guide",
      "phone": "+56 9 0000 0000",
      "email": "contact@supayexpedition.com"
    }
  ]
} as const satisfies Contact;
